(function() {
  'use strict';

  /**
   * AgendaController declaration
   */
  angular
    .module('webAgro1App')
    .controller('AgendaCtrl', AgendaController);

  /**
   * AgendaController dependencies
   * @type {Array}
   */
  AgendaController.$inject = [
    'date',
    '$uibModalInstance',
    'AgendaService',
    '$rootScope',
    '$q',
    'UsuariosService',
    'LoadingService',
    'TarefasService',
    'MessagesService',
    '$timeout'
  ];

  /**
   * AgendaController function
   */
  // eslint-disable-next-line max-len, max-lines-per-function, max-params
  function AgendaController(date, $uibModalInstance, AgendaService, $rootScope, $q, UsuariosService, LoadingService, TarefasService, MessagesService, $timeout) {
    // eslint-disable-next-line no-var
    var vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.dates = [];
    vm.creating = false;
    vm.creatingData = {};
    vm.loading = true;
    vm.datePickerOptions = {
      showWeeks: false
    };
    vm.popupData = {
      openedData: false,
      format: 'dd/MM/yyyy'
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.close = Close;
    vm.openTask = OpenTask;
    vm.createTask = CreateTask;
    vm.saveNewTask = SaveNewTask;
    vm.period = null;

    //////////////////////////////////////////
    // Function declarations
    function Close() {
      $uibModalInstance.close();
    }

    function Load() {
      vm.loading = true;
      // eslint-disable-next-line no-var
      var promise;

      if (date) {
        promise = AgendaService.getTasksByDate(date);
      } else {
        promise = AgendaService.getTasksByPeriod();
      }

      promise.then(function(result) {
        vm.dates = result;
      }).finally(function() {
        vm.loading = false;
      });
    }

    function OpenTask($event, task) {
      if ($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }

      if (!task.loaded) {
        task.loading = true;
        // AgendaService.taskDetails(task).finally(function() {
        //   task.loading = false;
        //   task.open = !task.open;
        //   task.loaded = true;
        // });
        $timeout(function() {
          task.loading = false;
          task.open = !task.open;
          task.loaded = true;
        }, 500);
      } else {
        task.open = !task.open;
      }
    }

    function CreateTask(createDate) {
      vm.loading = true;
      vm.creatingData = {};
      // eslint-disable-next-line no-var
      var promises = [
        UsuariosService.list()
      ];
      $q.all(promises).then(function(result) {
        vm.loading = false;
        vm.creating = true;

        vm.responsaveis = result[0].data || [];

        vm.creatingData.dataInicial = moment(createDate).toDate();
        vm.creatingData.safra = $rootScope.safras.filter(function(safra) {
          return safra.current;
        })[0];
        vm.creatingData.tipo = {
          tipo: 'geral'
        };
        vm.creatingData.propriedade = $rootScope.currentPropriedade;
      });
    }

    // Sem UI acessível hoje (AgendaService.openModal não é chamado em lugar nenhum, WEB-V1).
    // Se este fluxo for reativado, precisa exigir pelo menos um ponto antes de salvar.
    function SaveNewTask(form) {
      if (form.$invalid) {
        return;
      }

      LoadingService.showLoading();
      TarefasService.save(vm.creatingData).then(function() {
        LoadingService.hideLoading();
        MessagesService.alert('Tarefa salva com sucesso!');
        form.$setPristine();
        vm.creating = false;
        Load();
      }, function(error) {
        LoadingService.hideLoading();
        if (error.data && error.data.glebas) {
          MessagesService.alert(error.data.glebas[0]);
        } else {
          MessagesService.alert('Não foi possível salvar a tarefa! Tente novamente!');
        }
      });
    }

    //////////////////////////////////////////
    // Controller logic

    Load();
  }

// eslint-disable-next-line padded-blocks
}());
